import { Dayjs } from 'dayjs'
import { RoleType } from 'src/models/User'

export const CONTRIBUTION_SEARCH_CONDITIONS_MAX_COUNT = 7

export type Contribution = {
  id: number
  iconSrc?: string
  publishedAt: Dayjs
  userId: number
  name: string
  companyName: string
  position?: string
  sell: string
  buy: string
  detail: string
  status: 'draft' | 'publish' | 'force_stop'
  paidPlan?: boolean
  role?: RoleType | undefined
  typeOfPurchase: 'buy' | 'consultation' | 'sell'
  consultation: string
  isBuy: boolean
  isConsultation: boolean
  specialties?: number[]
  background?: string
  budget?: string
  introductionTiming?: string
  feedbackScore?: number
  feedbackCount?: number
}

export type ContributionsQueryParam = {
  page?: number
  keyword?: string
  type?: 'buy' | 'sell' | 'consultation'
  use_keyword?: boolean
  ['keyword_ids[]']?: string[]
  free_word?: string
  type_of_purchase?: string
  specialties?: string
  budget?: string
  introduction_timing?: string
}

export type ContributionUpdateParam = {
  id?: number
  buy: string
  sell: string
  status?: Contribution['status']
  detail?: string
  isShareFb?: boolean
  typeOfPurchase: Contribution['typeOfPurchase']
  consultation: string
  specialties?: number[]
  background?: string
  budget?: string
  introductionTiming?: string
}

export type ContributionMessage = {
  userId: number
  name: string
  companyName: string
  ionSrc?: string
  roomUrl: string
  contributionId?: number
  createdAt: Dayjs
}

export type ContributionKeywordsParam = {
  id: number
  companyId: number
  kind: 'buy' | 'sell'
  keyword: string
  isHidden?: boolean
}

export type ContributionFbShareParam = {
  buy: string
  sell: string
}

export type ContributionSearchConditionsDataParam = {
  budget?: string
  freeWord?: string
  introductionTiming?: string
  specialties?: string
  typeOfPurchase?: string
}

export type ContributionSearchConditionsData = {
  id: number
  companyId: number
  title: string
  params?: ContributionSearchConditionsDataParam
  createdAt: string
  updatedAt: string
}
